import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import variables from "../../constants/assets/variables";
import FileUpload from "../Common/FileUpload";
import NoFooterModal from "../Common/NoFooterModal";
import * as BulkUploadDriverPropertiesActions from "../../store/actions/BulkUploadDriverProperties";
import * as UserActions from "../../store/actions/User";
import Errors from "../../constants/Errors.json";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import InformationBar from "../Common/InformationBar";
import {
  Link,
  BottomSectionModal,
  UploadCsvOption,
  NotesSection,
} from "../../constants/assets/containers";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FileUploadModal = ({
  getDriverPropertiesOptions,
  getUploadUrl,
  setStatus,
}) => {
  const history = useHistory();

  const [activeFile, setActiveFile] = useState("");
  const [callbackKey, setCallbackKey] = useState("");
  const [presignUrl, setPresignUrl] = useState("");
  const [filePath, setFilePath] = useState("");
  const [propertyKey, setPropertyKey] = useState("");
  const [instituteNames, setInstituteNames] = useState([]);
  const [options, setOptions] = useState();
  const [optionalData, setOptionalData] = useState([]);
  const [sampleDownloadUrl, setSampleDownloadUrl] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);

  const handleClose = () => {
    history.push("/");
  };

  const handleSubmit = (e) => {
    setLoadingBtn(true);
    e.preventDefault();
    getUploadUrl({
      filename: "bulk_upload_driver_properties",
    }).then((res) => {
      setTimeout(() => setLoadingBtn(false), 3000);
      if (res) {
        setFilePath(res.file_path);
        setCallbackKey(res.callback_key);
        setPresignUrl(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const handlePropertyKeyChange = (key, val) => {
    setPropertyKey(val);

    if (val === "") {
      setSampleDownloadUrl("");
      return;
    }
    //sample download link for first_responder_training property bulk upload
    const download_url = `${process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        variables.sampleFileEndPoint
      )}/sample/bulk_upload_driver_properties_` + val + ".csv"
      : ""
      }`;
    setSampleDownloadUrl(download_url);
  };

  const handleInstituteNameChange = (key, val) => {
    // clearing the already selected institute_name or any other option selected
    let prev_optional_data = optionalData;
    if (optionalData && optionalData.length > 1)
      prev_optional_data = prev_optional_data.slice(0, 1);

    //storing institute's label in optional_data
    let index = instituteNames.findIndex((value) => value === val);
    if (index !== -1) {
      prev_optional_data.push({
        key: "institute_label",
        value: options.institute_names[index].label,
      });
      setOptionalData(prev_optional_data);
    }
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "" || propertyKey === "";
  };

  const showExplicitEntries = () => {
    // add more cases to handle multiple properties
    switch (propertyKey) {
      case "first_responder_training":
        return (
          <PaginatedReactDropdown
            options={instituteNames}
            keyToChange={options}
            handleChange={handleInstituteNameChange}
            placeholder="Institute Names"
            showCross={true}
            id="fileTypeDropdown"
            showPagination={false}
            labelWidth="fit-content"
          />
        );
      default:
    }
  };

  useEffect(() => {
    //loading keys (driver property name) if not present
    if (!options) {
      setLoadingBtn(true);
      getDriverPropertiesOptions().then((res) => {
        setOptions(res);
      });
      setTimeout(() => setLoadingBtn(true), 1000);
    }

    // setting optionalData if propertyKey selected
    if (propertyKey) {
      setOptionalData([{ key: "Key", value: propertyKey }]);
    }

    // handle events for different property keys
    switch (propertyKey) {
      case "first_responder_training":
        if (options && options.institute_names) {
          let institutes = options.institute_names,
            instituteNames = [];
          institutes.forEach((institute) => {
            instituteNames.push(institute.name);
          });
          setInstituteNames(instituteNames);
        }
    }
  }, [propertyKey]);

  return (
    <BulkUploadDriverPropertiesModal>
      <NoFooterModal
        header
        heading="Bulk Upload Driver Properties"
        handleClose={handleClose}
        id="BulkUploadDriverPropertiesModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="assignCourse"
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              className="sushi-btn"
            // loading={loadingBtn}
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
          options={options ? options.keys : []}
          handleChange={handlePropertyKeyChange}
          labelKey="label"
          valueKey="value"
          keyToChange={propertyKey}
          placeholder="Driver Property"
          showCross={true}
          id="fileTypeDropdown"
          showPagination={true}
          labelWidth="fit-content"
        />
        {showExplicitEntries()}
        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl="/drivers/properties/bulk-update-properties/ack"
            callback_key={callbackKey}
            presign_url={presignUrl}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            acceptTypes=".csv, .xls, .xlsx"
            extraParamsAckObj={{
              file_path: filePath,
              callback_key: callbackKey,
              presign_url: presignUrl,
              data: JSON.stringify(optionalData),
            }}
            validationType={"DriverProperties:" + propertyKey}
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sampleDownloadUrl}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </BulkUploadDriverPropertiesModal>
  );
};

const BulkUploadDriverPropertiesModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUploadDriverPropertiesActions.getUploadUrl,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getDriverPropertiesOptions: bindActionCreators(
      BulkUploadDriverPropertiesActions.getDriverPropertiesOptions,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
